import type { UnproxiedEditorSDK } from '../types'
import type { Logger } from '../logger'
import { wrapWithBreadcrumbs } from './wrapWithBreadcrumbs'

export const initEditorSDK = (
  logger: Logger,
  editorSDK: UnproxiedEditorSDK,
) => {
  const sdk = wrapWithBreadcrumbs({
    editorSDK,
    onBreadcrumb: (bc: any) => logger.breadcrumb(bc),
  })

  const addEventListener = sdk.addEventListener
  sdk.addEventListener = (
    event: string,
    handler: (...eventData: any[]) => any,
  ) =>
    addEventListener(event, async (...eventData: any[]) => {
      try {
        return await handler(...eventData)
      } catch (cause) {
        logger.error(
          new Error('editorSDK.addEventListener handler failed', {
            cause,
          }),
          { event, eventData },
        )
      }
    })

  return sdk
}
